module.exports = __webpack_public_path__ + "si.70c6e3a3f689078c9f75.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/si.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/si.svg
// module chunks = styles